import { defineMessages } from 'react-intl';

const formActionsMessages = defineMessages({
    confirm: {
        defaultMessage: 'Zeker weten?',
    },
    alert: {
        defaultMessage: 'Invoer onjuist',
    },
});

export default formActionsMessages;
